
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"23","fill":"none"}},[_c('path',{attrs:{"fill":"#181631","d":"M21.354 5.646a.502.502 0 00-.708.708l.708-.708zM27 12l.354.354a.502.502 0 000-.708L27 12zm-6.354 5.646a.502.502 0 00.708.708l-.708-.708zM11 11.5a.5.5 0 000 1v-1zm9.646-5.146l6 6 .708-.708-6-6-.708.708zm6 5.292l-6 6 .708.708 6-6-.708-.708zM27 11.5H11v1h16v-1z"}})])
      }
    
      }
    